import { render } from "./Strategies.vue?vue&type=template&id=703272b0"
import script from "./Strategies.vue?vue&type=script&lang=js"
export * from "./Strategies.vue?vue&type=script&lang=js"
script.render = render

export default script